import React from 'react';

import Home from '../features/Home/Home';

function HomePage() {
	return <Home />;
}

export default HomePage;
